import React from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as ApproveIcon } from "assets/icons/modal-approve-icon.svg";
import { ReactComponent as RejectIcon } from "assets/icons/modal-reject-icon.svg";

import { IModalHeaderProps, THeaderIconMap } from "./types";

export const ModalHeader = (props: IModalHeaderProps) => {
  const { modalType, className, HeaderIcon, children, modalHeaderCss } = props;

  const HeaderIconMap: THeaderIconMap = {
    approval: <ApproveIcon />,
    rejection: <RejectIcon />,
    others: HeaderIcon ? HeaderIcon : <></>,
  };

  return (
    <Box
      className={`mb-5 w-full flex justify-start ${className ?? ""}`}
      css={modalHeaderCss}
    >
      <div className="h-8 w-8">{HeaderIconMap[modalType]}</div>
      <>{children}</>
    </Box>
  );
};
